import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import reportWebVitals from "./reportWebVitals";
import "./index.css";
import App from "./App";
import { I18nProvider } from "./i18n";

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.NODE_ENV,
  enabled: process.env.NODE_ENV === "production" && !!process.env.REACT_APP_SENTRY_DSN,
  tracesSampleRate: 0.2,
  sendDefaultPii: false,
  beforeSend(event, hint) {
    if (hint?.originalException?.response?.status === 401) return null;
    return event;
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <I18nProvider>
      <App />
    </I18nProvider>
  </React.StrictMode>,
);

reportWebVitals();
